export default "__VITE_ASSET__DWNvClSB__"